export default __webpack_public_path__ + "static/media/green_pepper.ecf0b46b.png";